import React, { useState, useEffect } from 'react';
import { Coins } from 'lucide-react';
import { getUserCredits, UserCredits } from '../lib/credits';

export function CreditsDisplay() {
  const [credits, setCredits] = useState<UserCredits | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadCredits = async () => {
      const userCredits = await getUserCredits();
      setCredits(userCredits);
      setIsLoading(false);
    };

    loadCredits();
    
    // Odświeżaj co 5 minut
    const interval = setInterval(loadCredits, 300000);
    return () => clearInterval(interval);
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg animate-pulse">
        <Coins className="w-5 h-5 text-gray-400" />
        <div className="w-16 h-4 bg-gray-200 rounded"></div>
      </div>
    );
  }

  if (!credits) {
    return null;
  }

  const isLow = credits.credits < 100;
  const isCritical = credits.credits < 50;

  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-lg border ${
      isCritical
        ? 'bg-red-50 border-red-300'
        : isLow
          ? 'bg-yellow-50 border-yellow-300'
          : 'bg-emerald-50 border-emerald-200'
    }`}>
      <Coins className={`w-5 h-5 ${
        isCritical ? 'text-red-500' : isLow ? 'text-yellow-500' : 'text-emerald-500'
      }`} />
      <span className={`font-semibold ${
        isCritical ? 'text-red-700' : isLow ? 'text-yellow-700' : 'text-emerald-700'
      }`}>{credits.credits}</span>
      <span className={`text-sm ${
        isCritical ? 'text-red-600' : isLow ? 'text-yellow-600' : 'text-emerald-600'
      }`}>kredytów</span>
    </div>
  );
}